import { useAuth } from '../contexts/AuthContext';
import { hasPermission, PermissionKey } from '../config/permissions';

/**
 * Hook เช็คสิทธิ์พนักงาน — merchant owner ผ่านทุกสิทธิ์เสมอ
 * (manager นับเป็น employee เหมือนเดิม ตาม Layout filterItem)
 */
export const usePermissions = () => {
  const { merchant } = useAuth();
  const isEmployee = merchant?.role === 'employee' || merchant?.type === 'employee';

  const can = (key: PermissionKey | PermissionKey[]): boolean =>
    !isEmployee || hasPermission(merchant?.permissions, key);

  return { isEmployee, isOwner: !isEmployee, can };
};
